module.exports = __webpack_public_path__ + "static/img/Ray Fajar Salinggih-full.c77728b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Ray Fajar Salinggih-full.png
// module id = m1eC
// module chunks = 1